import { motion } from 'framer-motion'
import React from 'react'
import ReactPlayer from 'react-player'

import { getAnimationParams } from '../../helpers/animations'
import { getStringFromJSX } from '../../helpers/getStringFromJSX'
import Breadcrumbs from '../UI/Breadcrumbs/Breadcrumbs'
import styles from './aboutProject.module.scss'
import { PageProps } from './AboutProjects.types'

export const AboutProject = ({
  title,
  text,
  image,
  mainPage,
  video,
  classModifiers,
  breadcrumbs,
}: PageProps) => {
  const classList = classModifiers
    ? classModifiers.map(
        (el: string) => `${styles['aboutProjectWrapper--' + el]}`
      )
    : []

  return (
    <div className={`${styles.aboutProjectWrapper} ${classList?.join(' ')}`}>
      <motion.div {...getAnimationParams(-700)} className={styles.leftSide}>
        {breadcrumbs && (
          <Breadcrumbs
            arrayLinks={breadcrumbs}
            classModifiers={classModifiers}
          />
        )}
        <h1 style={{ whiteSpace: 'pre-wrap' }}>{title}</h1>
        <p
          className={mainPage && styles.mainPageDescription}
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {text}
        </p>
      </motion.div>
      <motion.div className={styles.rightSide} {...getAnimationParams(800)}>
        {video ? (
          <ReactPlayer
            url={video.src}
            width='100%'
            height='100%'
            playing
            muted
            loop
            playsinline
          />
        ) : (
          <img src={image} alt={getStringFromJSX(title)} />
        )}
      </motion.div>
    </div>
  )
}
